import { gql } from '@apollo/client';
import React, { FunctionComponent } from 'react';
import { InMemoryCtaFragment } from '../../../types/__generated__';
import { buildQuery, usePageQuery } from '../../hooks';
import { InMemoryCreateFundraisingPageButton } from '../InMemoryCreateFundraisingPageButton/InMemoryCreateFundraisingPageButton';
import { Share } from '../SocialButtons/Share';

const FRAGMENT = buildQuery(gql`
  fragment InMemoryCta on Page {
    inMemory {
      firstNameOfDeceased
    }
  }
`);

export const InMemoryCTA: FunctionComponent = () => {
  const { data } = usePageQuery<InMemoryCtaFragment>(FRAGMENT);

  const { firstNameOfDeceased } = data?.inMemory || {};

  return (
    <>
      <InMemoryCreateFundraisingPageButton
        firstNameOfDeceased={firstNameOfDeceased}
        className="jg-btn--themed jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingIdentifier="in-memory-cta-make-a-fundraising-page-button"
      />
      <Share
        buttonClassName="jg-btn--ghost"
        trackingIdentifier="in-memory-cta-share-button"
      />
    </>
  );
};
